import { render, staticRenderFns } from "./VariantRatesColumn.vue?vue&type=template&id=ae8080c4&scoped=true&"
import script from "./VariantRatesColumn.vue?vue&type=script&lang=js&"
export * from "./VariantRatesColumn.vue?vue&type=script&lang=js&"
import style0 from "./VariantRatesColumn.vue?vue&type=style&index=0&id=ae8080c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8080c4",
  null
  
)

export default component.exports